import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Redirect, withRouter } from "react-router-dom";

import { logoutUser } from "../../store/actions";
import { clearPostLoginRedirect } from "../../helpers/postLoginRedirect";

//redux
import { useSelector, useDispatch } from "react-redux";

const Logout = (props) => {
  const dispatch = useDispatch();

  const { isUserLogout } = useSelector((state) => ({
    isUserLogout: state.Login.isUserLogout,
  }));

  useEffect(() => {
    dispatch(logoutUser());
    //clear local storage
    localStorage.removeItem("authUser");
    localStorage.removeItem("firebase_fcm_token");
    clearPostLoginRedirect(); // Change #100336 - and its owner/time stamp
    //and the nredirect to login page
    props.history.push("/login");
  }, [dispatch]);

  if (isUserLogout) {
    return <Redirect to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
